import createIcon from '../../createIcon';

/**
 * @component @name CameraRear
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMjBINVYyMkgxMFYyNEwxMyAyMUwxMCAxOFYyMFpNMTQgMjBWMjJIMTlWMjBIMTRaTTE3IDBIN0M1LjkgMCA1IDAuOSA1IDJWMTZDNSAxNy4xIDUuOSAxOCA3IDE4SDE3QzE4LjEgMTggMTkgMTcuMSAxOSAxNlYyQzE5IDAuOSAxOC4xIDAgMTcgMFpNMTIgNkMxMC44OSA2IDEwIDUuMSAxMCA0QzEwIDIuOSAxMC44OSAyIDExLjk5IDJDMTMuMDkgMiAxMy45OSAyLjkgMTMuOTkgNEMxNCA1LjEgMTMuMSA2IDEyIDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CameraRear = createIcon('CameraRear', [
  [
    'path',
    {
      d: 'M10 20H5V22H10V24L13 21L10 18V20ZM14 20V22H19V20H14ZM17 0H7C5.9 0 5 0.9 5 2V16C5 17.1 5.9 18 7 18H17C18.1 18 19 17.1 19 16V2C19 0.9 18.1 0 17 0ZM12 6C10.89 6 10 5.1 10 4C10 2.9 10.89 2 11.99 2C13.09 2 13.99 2.9 13.99 4C14 5.1 13.1 6 12 6Z',
      key: '8gan6a',
    },
  ],
]);

export default CameraRear;
